module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(!_vm.getProfileHaveClient) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Служба контрагентов. ")])]), _vm._v(" "), _c('v-card-text', [_vm._v("\n        Служба контрагентов позволяет быстро находить избранных контрагентов, ставить их на мониторинг в егрюл, позволяет группировать контрагентов по спискам, а также вести протокол просмотра контрагентов.\n        Для работы с избранными контрагентами, необходимо определить Юридическое лицо которое Вы представляете.\n        Регистрируйтесь и общайтесь от имени Вашей компании.\n      ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "to": "/register"
    }
  }, [_vm._v("Регистрация")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getProfileHaveClient && !_vm.$route.params.cagentId) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [_c('v-favorite-company-set', {
    attrs: {
      "tagIds": _vm.tagIds
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.getProfileHaveClient && _vm.$route.params.cagentId) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [_c('v-c-agent-page', {
    attrs: {
      "itemId": _vm.$route.params.cagentId
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d39f42e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/favorite/FavoriteCompanyPanel.vue
// module id = 1136
// module chunks = 1